/**
 * Mockup v3 P6 (Diagramas): the strings of the drawer's two diagram tabs, the version picker, the
 * empty, drawing and drawn states and the four structured refusals. Spread into `es` by `es.ts`;
 * P6 adds its keys here only. Copy from `mockup-ux-redesign-v3.html` (`DG_TABS`, `diagramPane`,
 * `DG_REFUSAL`). No amount is written here: the drawn line's `{cost}` ("USD 0.02", with a dot) is
 * filled by the container for an editor only (P7-1, OD-12 note "P7"); the v3 "cuesta unos USD 0,02"
 * of the empty state stays out (the price of a draw is stated inside its consent dialog, F-UIX-025).
 */
export const esDiagrams = {
  "diagram.tabs.label": "Tipo de diagrama",
  "diagram.tabs.journey": "Flujo de la pantalla",
  "diagram.tabs.walkthrough": "Recorrido entre pantallas",
  "diagram.lower.journey": "el flujo de la pantalla",
  "diagram.lower.walkthrough": "el recorrido entre pantallas",
  "diagram.tab.drawn": "(dibujado)",
  "diagram.tab.notDrawn": "(sin dibujar)",
  "diagram.version.label": "Versión",
  "diagram.version.option": "v{n}",
  "diagram.version.optionCurrent": "v{n} (actual)",
  "diagram.version.hint": "Cada versión guarda sus dos diagramas.",
  "diagram.version.readOnly":
    "Solo se dibuja con la versión actual: aquí ves los diagramas que esta versión ya guardó.",
  "diagram.empty.title": "La v{n} todavía no tiene {diagram}",
  "diagram.empty.body.journey": "Las pantallas y cómo se pasa de una a otra dentro del mockup.",
  "diagram.empty.body.walkthrough": "Cada pantalla dibujada como un marco, en el orden en que la recorre quien la usa.",
  "diagram.empty.draw": "Dibujar {diagram}",
  "diagram.empty.help": "Tarda unos 20 s · se guarda con la v{n}",
  "diagram.drawing.title": "Dibujando {diagram} de la v{n}…",
  "diagram.drawing.body": "Suele tardar unos 20 segundos. Puedes cerrar el panel: se guarda con la versión.",
  "diagram.drawn.help": "Dibujado con la v{n}.",
  "diagram.drawn.helpToday": "Dibujado con la v{n} hoy a las {time} · {cost}.",
  "diagram.drawn.helpDay": "Dibujado con la v{n} el {day} · {cost}.",
  "diagram.drawn.redraw": "Volver a dibujar",
  "diagram.drawn.download": "Descargar (ZIP)",
  "diagram.drawn.share": "Compartir",
  "diagram.drawn.downloadFailed": "No se pudo descargar el diagrama.",
  "diagram.drawn.redrawDisabled":
    "No se puede volver a dibujar: cada versión se dibuja una sola vez. Para otro diagrama, crea una versión nueva.",
  "diagram.frame.walkthrough": "Diagrama del recorrido entre pantallas",
  "diagram.legend.walkthrough": "Cada marco es una pantalla del mockup, en el orden en que se recorren",
  "diagram.legend.label": "Leyenda del diagrama",
  "diagram.legend.screen": "Pantalla",
  "diagram.legend.action": "Flecha: lo que hace quien la usa",
  "diagram.legend.start": "Borde de color: pantalla de inicio",
  "diagram.legend.alternative": "— — Camino alternativo",
  "diagram.refusal.title": "No se dibujó.",
  "diagram.refusal.noVersion":
    "Todavía no hay nada que dibujar: el diagrama se hace a partir de una versión generada del mockup.",
  "diagram.refusal.diagramAlreadyDrawn":
    "No se puede volver a dibujar: cada versión se dibuja una sola vez. Para otro diagrama, crea una versión nueva.",
  "diagram.refusal.diagramInProgress":
    "Ya se está dibujando un diagrama de la v{n}. Espera a que termine: no se cobra dos veces. Si sigue sin terminar, vuelve a intentarlo en unos minutos.",
  "diagram.refusal.journeyRequired":
    "El recorrido entre pantallas parte del flujo de la pantalla, y esta versión todavía no lo tiene dibujado. Dibuja primero el flujo de la pantalla.",
  "diagram.refusal.toJourney": "Ir al flujo de la pantalla",
  "version.artifact.diagramWalkthrough": "Recorrido entre pantallas",
} as const;
